import { FaGithub } from 'react-icons/fa';
import React from 'react';
import { Container } from 'react-bootstrap';
import TypewriterComponent from 'typewriter-effect';
import '../styles/Hero.css';

export default function Hero() {
    const handleHover = (e) => {
        const field = e.target.innerText;
        switch (field) {
            case 'LABIB':
                e.target.innerText = 'About';
                break;
            case 'MAHFUZ':
                e.target.innerText = 'Skills'
                break;
            case 'TONAY':
                e.target.innerText = 'Works'
                break;
            default:
                break;
        };
    };

    const handleMouseOut = (e) => {
        const field = e.target.innerText;
        switch (field) {
            case 'About':
                e.target.innerText = 'Labib';
                break;
            case 'Skills':
                e.target.innerText = 'Mahfuz'
                break;
            case 'Works':
                e.target.innerText = 'Tonay'
                break;
            default:
                break;
        };
    };

    return (
        <Container>
            <header
                className="d-flex text-center align-items-center justify-content-center flex-column"
                style={{ minHeight: `${window.innerHeight - 100}px`, paddingBottom: '83px' }}
            >
                <h1 className="name">
                    <a href='#about' onMouseEnter={handleHover} onMouseOut={handleMouseOut} className="text me-3 text-labib">Labib</a>
                    <a href='#skills' onMouseEnter={handleHover} onMouseOut={handleMouseOut} className="text text-mahfuz">Mahfuz</a>
                    <a href='#works' onMouseEnter={handleHover} onMouseOut={handleMouseOut} className="text ms-3 text-tonay">Tonay</a>
                </h1>
                <h4 className='tw-ani d-flex'><TypewriterComponent
                    options={{
                        strings: ['Full Stack Web', 'React Native', 'Android Application', 'Front End Web', 'Single Page Web Application'],
                        autoStart: true,
                        loop: true,
                    }}
                />Developer</h4>
                <div className="social-links d-flex">
                    <a target="_blank" className='gthb-btn d-flex align-items-center justify-content-between' rel="noreferrer noopener" href="https://www.github.com/lmtonay"><FaGithub className='icon me-3'></FaGithub> <span>Visit GitHub</span></a>
                </div>
            </header>
        </Container>
    );
};